import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { Awesome } from "@components/Helpers";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

function List({ gameId, header }) {
    const { t } = useTranslation();
    const apiUrl = url_reverse("api:game:betatester:upload_list", { game_id: gameId });
    const { apiData, setApiData } = useAppApi(apiUrl);
    const { api_post } = useRequest();

    if (!apiData) return;

    const deleteAction = (id) => {
        api_post(null, apiUrl, {
            params: { action: "delete", id },
            then: (resp) => setApiData(resp),
        });
    };

    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "5%" }}>ID</th>
                        <th>{t("Действие")}</th>
                        <th>{t("Состояние")}</th>
                        <th>{t("Auth system")}</th>
                        <th>{t("Дата")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((item) => (
                        <tr key={`item_${item.id}`}>
                            <td>{item.id}</td>
                            <td>{item.action}</td>
                            <td>{item.state}</td>
                            <td>{item.auth_system}</td>
                            <td>{item.date_added}</td>
                            <td className="dmg-table-row-tools">
                                <Awesome type="trash-o" color="red" onClick={() => deleteAction(item.id)} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}

export default function BetatestersUploadList(props) {
    return <List {...props} />;
}
